module.exports = __webpack_public_path__ + "img/step-arrow-top.1ae0e538.png";